// extracted by mini-css-extract-plugin
export var imgContainer = "projects-module--imgContainer--gwPYk";
export var projectDescription = "projects-module--projectDescription--NhDXk";
export var projectList = "projects-module--projectList--rlfWn";
export var projectTitle = "projects-module--projectTitle--0C-3t";
export var projectsContainer = "projects-module--projectsContainer--SGZ8t";